import { Environment, CameraControls, Html, PerspectiveCamera, Sparkles } from '@react-three/drei'
import { EffectComposer, Autofocus } from '@react-three/postprocessing'
import { useThree } from '@react-three/fiber'
import { useEffect, useRef } from 'react'
import useGame from './stores/useGame.jsx'
import * as THREE from'three'
import { Expand, Contract } from "./Audio.jsx"
import { Leva, useControls } from 'leva'
import { CR90 } from './CR90.jsx'
import { Bloom,  Noise,  Vignette } from '@react-three/postprocessing'
import { Resolution, BlendFunction, KernelSize } from 'postprocessing'



const { DEG2RAD } = THREE.MathUtils

var audioTrigger = false

export default function Experience()
{
    const phase = useGame((state) => state.phase)
    const touched = useGame((state) => state.touched)
    const animFinished = useGame((state) => state.animFinished)

    
    const renderState = useThree()
    const cameraControlsRef = useRef()
    const sunRef = useRef()

    const p1 = useGame((state) => state.p1)
    const p2 = useGame((state) => state.p2)
    const p3 = useGame((state) => state.p3)
    const p4 = useGame((state) => state.p4)
    const p5 = useGame((state) => state.p5)
    const p6 = useGame((state) => state.p6)

    const infoPanel = useGame((state) => state.infoPanel)

    const efRef = useRef()
    const dofRef = useRef()

    const {...efConfig} = useControls('PostProcessing',{
        enabled: true
    })

    
    const {...dofConfig} = useControls('DOF',{
        focalLength: {value: 0.50, min: 0.00, max: 0.50, step: 0.01},
        focusRange: { min: 0, max: 1, value: 0.01 },
        bokehScale: {value: 4.0, min: 0.0, max: 5.0, step: 0.1}
    })



    useEffect(() =>
    {
        const state = useGame.getState()

            if (state.infoPanel === 'null')
                { 
                    cameraControlsRef.current?.reset(true)
                }        
    }, [infoPanel])



        const LaunchPoint = (panelNumber, position, target) =>
        {
            panelNumber()
            console.log(position)
            console.log(target)
            cameraControlsRef.current.setLookAt(...position, ...target, true)
        }


        const Points = () =>
            {

            return  <>

                    { animFinished === true && infoPanel === 'null' &&<>
                        <Html wrapperClass='point' position={new THREE.Vector3(3.2, -0.1, 0)}  > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p1, new THREE.Vector3(6.2, 0.5, -1.5), new THREE.Vector3(3.2, -0.1, 0)) } }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p1, new THREE.Vector3(6.2, 0.5, -1.5), new THREE.Vector3(3.2, -0.1, 0)) } }>1</div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(2.0, 0.0, 0)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p2, new THREE.Vector3( 3, 0.8, 1 ), new THREE.Vector3(2.0, -0.1, 0))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p2, new THREE.Vector3( 3, 0.8, 1 ), new THREE.Vector3(2.0, -0.1, 0))} }>2</div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(1.2, -0.5, 0.0)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p3, new THREE.Vector3( 1.4, -0.6, -1.5), new THREE.Vector3(1.2, -0.4, 0.0))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p3, new THREE.Vector3( 1.4, -0.6, -1.5), new THREE.Vector3(1.2, -0.4, 0.0))} }>3</div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3( -0.10, 0, 0.0)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p4, new THREE.Vector3( 1, 1, 1), new THREE.Vector3(-0.10, 0, 0.0))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p4, new THREE.Vector3( 1, 1, 1), new THREE.Vector3(-0.10, 0, 0.0))} }>4</div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(-0.10, -0.3, -0.6)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p5, new THREE.Vector3( -0.9, 0, -2.2), new THREE.Vector3(-0.10, -0.3, -0.6))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p5, new THREE.Vector3( -0.9, 0, -2.2), new THREE.Vector3(-0.10, -0.3, -0.6))} }>5</div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(-2.8, 0, 0)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p6, new THREE.Vector3(-5, 1.5, -1), new THREE.Vector3(-2.5, 0, 0))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p6, new THREE.Vector3(-5, 1.5, -1), new THREE.Vector3(-2.5, 0, 0))} }>6</div> 
                        </Html>

                        </>
                    }

                    </>
            }
    


     return <>
            {/* <Perf /> */}
            <Leva hidden={true} />

                {/* <directionalLight 
                    ref={sunRef}
                    color={new THREE.Color( 0xffb365 )}
                    position={[10,5,10]} 
                    intensity={ 8 } 
                    castShadow 
                    shadow-mapSize={[4096, 4096]}
                    shadow-bias={-0.0002}
                    shadow-camera-top={10}
                    shadow-camera-bottom={-10}
                    shadow-camera-left={-20}
                    shadow-camera-right={20}
                    />
                 */}
                
                <CameraControls
                        ref={cameraControlsRef}
                        minDistance={6}
                        maxDistance={10}
                        onChange={touched}
                        minPolarAngle={Math.PI/2 - 0.8}
                        maxPolarAngle={Math.PI/2 - 0.1}
                        
                />

                    <PerspectiveCamera 
                        makeDefault
                        fov= {45}
                        near={0.1}
                        far={2000}
                        position= {[ 6.2, 3.0, -4.5 ]}
                    >       
                    </PerspectiveCamera>

                    <CR90 position={[0,-1,0]}  scale={2} />

                    <Points/>

                    <Sparkles 
                        size={ 3 }
                        scale={ [ 7, 3, 7 ] }
                        position-y={ 1 }
                        speed={ 0.3 }
                        count={ 100 }
                        color={ 'cyan' }
                    />

                    
                    
                    <EffectComposer ref={efRef} {...efConfig}>
            
                        {/* <Autofocus
                            ref={dofRef}
                            target={[0,0,0]}
                            width={1024}
                            height={1024}
                            {...dofConfig}

                        /> */}

                    <Bloom
                        intensity={0.1} // The bloom intensity.
                        kernelSize={KernelSize.LARGE} // blur kernel size
                        luminanceThreshold={0.1} // luminance threshold. Raise this value to mask out darker elements in the scene.
                        luminanceSmoothing={0.3} // smoothness of the luminance threshold. Range is [0, 1]
                        mipmapBlur={true} // Enables or disables mipmap blur.
                        resolutionX={Resolution.AUTO_SIZE} // The horizontal resolution.
                        resolutionY={Resolution.AUTO_SIZE} // The vertical resolution.
                    />

                    <Noise
                        premultiply // enables or disables noise premultiplication
                        blendFunction={BlendFunction.DARKEN} // blend mode
                        opacity={0.2}

                    />

                    <Vignette
                        offset={0.1} // vignette offset
                        darkness={0.9} // vignette darkness
                        eskil={false} // Eskil's vignette technique
                        blendFunction={BlendFunction.DARKEN} // blend mode
                        opacity={1}
                    />


                    
                    </EffectComposer>


    </>
}